function getEnv(sld) {
	return {
		ancestrydev: 'dev',
		ancestrystage: 'stage'
	}[sld] || 'live';
}

// Assumes a single subdomain (which all Ancestry domains have)
function getDomainParts(hostname) {
	const [subdomain, sld, ...tldParts] = hostname.split('.');
	const tld = tldParts.join('.');
	return { subdomain, sld, tld };
}

function getLocale() {
	return (document.documentElement.lang || 'en-us').toLowerCase();
}

function getLoadPreviousState() {
	return window.ui.getUrlParameterValue('evalflow') === 'true';
}

function getUiCdnUrl(cdnUrl) {
	return `${cdnUrl}/ui/${((((document.querySelector(`link[href^="${cdnUrl}/ui/"][href$="core.css"]`) || {}).href || '').split('/ui/')[1] || '2.9.3').split('/css/')[0])}`;
}

function getConfig(renderer = 'sidebar', overrides) {
	const cdnUrl = 'https://www.ancestrycdn.com';
	const { sld, tld } = getDomainParts(window.location?.hostname);
	const locale = getLocale();
	const env = getEnv(sld);
	const uiCdnUrl = getUiCdnUrl(cdnUrl);
	const ancestryUrl = window.location?.origin;
	const newspapersUrl = 'https://img.newspapers.com';
	const mediaSvcUrl = `https://mediasvc.${sld}.${tld}`;
	const placePFXUrl = `https://placepfx.${sld}.com`;
	const personPageUrlPrefix = `${ancestryUrl}/family-tree/person`;
	const searchUrl = `https://search.${sld}.${tld}`;
	const hintsUiApiUrlPrefix = `${ancestryUrl}/api/hintsui-api`;
	const personHintsApiUrl = `${ancestryUrl}/hintsui-personhints/api`;
	const hintsUiEvalCdnUrl = EVAL_VERSION ? `${cdnUrl}/hintsui-eval/${EVAL_VERSION}` : 'https://www.ancestrystage.com/hintsui-eval'; // eslint-disable-line no-undef
	const loadPreviousState = getLoadPreviousState();
	const config = {
		ancestryUrl,
		cdnUrl,
		newspapersUrl,
		uiCdnUrl,
		hintsUiEvalCdnUrl,
		env,
		hintsUiApiUrlPrefix,
		locale,
		loadPreviousState,
		mediaSvcUrl,
		placePFXUrl,
		personPageUrlPrefix,
		personHintsApiUrl,
		searchUrl,
		renderer
	};

	return overrides ? Object.assign(config, overrides) : config;
}

export default getConfig;
